module.exports = __webpack_public_path__ + "static/img/10.21b47ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/10.png
// module id = J46F
// module chunks = 0